import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import SummarySection from '../../components/Summary/SummarySection';
import * as summaryValueMapper from './summaryValueMapper';
import * as applicationActions from '../../actions/applicationActions';
import * as identityActions from '../../actions/identityActions';
import * as addressActions from '../../actions/addressActions';
import * as contactActions from '../../actions/contactActions';
import * as summaryRowTypes from '../../components/Summary/summaryRowTypes';
import { isTselCountry } from '../contactSearchAndFormat';
import Config from '../../Config';

const config = new Config();

export class SummaryPersonalInfoContainer extends React.Component {
  componentDidMount() {
    if (!this.props.application) {
      this.props.actions.fetchApplication(this.props.applicationId, this.props.authToken);
    }
    if (!this.props.identity) {
      this.props.actions.fetchIdentity(this.props.applicationId, this.props.authToken);
    }
    if (!this.props.address) {
      this.props.actions.fetchAddress(this.props.applicationId, this.props.authToken);
    }
  }

  render() {
    return (
      <SummarySection {...this.props} />
    );
  }
}

SummaryPersonalInfoContainer.propTypes = {
  actions: PropTypes.shape({
    fetchApplication: PropTypes.func,
    fetchAddress: PropTypes.func,
    fetchIdentity: PropTypes.func,
  }).isRequired,
  application: PropTypes.shape(),
  applicationId: PropTypes.string.isRequired,
  authToken: PropTypes.string.isRequired,
  address: PropTypes.shape(),
  identity: PropTypes.shape(),
};

const parseDate = (dateValue) => {
  const d = dateValue ? dateValue.toString().slice(0, 10).split('-') : [];
  return d.length === 3 ? `${d[1]}/${d[2]}/${d[0]}` : '';
};

function findContactByType(contactType, contacts) {
  return contacts.find((c) => { return c.type === contactType; });
}

function findIdentityByContactId(contactId, identities) {
  return identities.find((a) => { return a.contactId === contactId; });
}

function findAddressByContactId(contactId, addresses) {
  return addresses.find((a) => { return a.contactId === contactId; });
}

function mapStateToInitialValues(state, groupIndex) {
  const contacts = (state && state.contact && state.contact.length > 0) ? state.contact : null;
  const addresses = (state && state.address && state.address.length > 0) ? state.address : null;
  const identities = (state.identity && state.identity.length > 0) ? state.identity : null;

  let isLoading = true;

  if (state.identity && state.address) {
    isLoading = false;
  }

  let address = null;
  let identity = null;

  const contactType = (groupIndex === 0) ? 'primary' : 'joint';
  const contact = contacts ? findContactByType(contactType, contacts) : null;
  if (contact) {
    address = addresses ? findAddressByContactId(contact.id, addresses) : null;
    identity = identities ? findIdentityByContactId(contact.id, identities) : null;
  }

  let personalInformation = [
    {
      keyType: summaryRowTypes.SUMMARY_ROW_EDIT,
      valueType: summaryRowTypes.SUMMARY_ROW_EDIT,
      key: 'Identity',
      value: 'Identity',
    },
    {
      keyType: summaryRowTypes.SUMMARY_ROW_TXT,
      valueType: summaryRowTypes.SUMMARY_ROW_TXT,
      key: 'Country of Citizenship',
      value: identity ? summaryValueMapper.getCountryName(state.countries, identity.countryOfCitizenship) : '',
    },
    {
      keyType: summaryRowTypes.SUMMARY_ROW_TXT,
      valueType: summaryRowTypes.SUMMARY_ROW_TXT,
      key: 'Date of Birth',
      value: identity ? parseDate(identity.birthDate) : '',
    },
    {
      keyType: summaryRowTypes.SUMMARY_ROW_TXT,
      valueType: summaryRowTypes.SUMMARY_ROW_TXT,
      key: 'Social Security Number / Tax ID',
      value: identity ? identity.identificationSSN : '',
    },
    {
      keyType: summaryRowTypes.SUMMARY_ROW_EDIT,
      valueType: summaryRowTypes.SUMMARY_ROW_EDIT,
      key: 'Residential Address',
      value: 'Residential Address',
    },
    {
      keyType: summaryRowTypes.SUMMARY_ROW_TXT,
      valueType: summaryRowTypes.SUMMARY_ROW_TXT,
      key: 'Country',
      value: address ? summaryValueMapper.getCountryName(state.countries, address.residentialCountry) : '',
    },
    {
      keyType: summaryRowTypes.SUMMARY_ROW_TXT,
      valueType: summaryRowTypes.SUMMARY_ROW_TXT,
      key: 'Street Address 1',
      value: address ? address.residentialAddress1 : '',
    },
  ];

  if (address && address.residentialAddress2) {
    personalInformation = personalInformation.concat([
      {
        keyType: summaryRowTypes.SUMMARY_ROW_TXT,
        valueType: summaryRowTypes.SUMMARY_ROW_TXT,
        key: 'Street Address 2',
        value: address ? address.residentialAddress2 : '',
      },
    ]);
  }

  personalInformation = personalInformation.concat([
    {
      keyType: summaryRowTypes.SUMMARY_ROW_TXT,
      valueType: summaryRowTypes.SUMMARY_ROW_TXT,
      key: 'City',
      value: address ? address.residentialCity : '',
    },
    {
      keyType: summaryRowTypes.SUMMARY_ROW_TXT,
      valueType: summaryRowTypes.SUMMARY_ROW_TXT,
      key: 'State/Province',
      value: address ?
        summaryValueMapper.getRegionName(state.countries, address.residentialCountry, address.residentialRegion) :
        '',
    },
    {
      keyType: summaryRowTypes.SUMMARY_ROW_TXT,
      valueType: summaryRowTypes.SUMMARY_ROW_TXT,
      key: 'Zip/Postal Code',
      value: address ? address.residentialZip : '',
    },
    {
      keyType: summaryRowTypes.SUMMARY_ROW_EDIT,
      valueType: summaryRowTypes.SUMMARY_ROW_EDIT,
      key: 'Mailing Address',
      value: 'Mailing Address',
    },
    {
      keyType: summaryRowTypes.SUMMARY_ROW_TXT,
      valueType: summaryRowTypes.SUMMARY_ROW_TXT,
      key: 'Country',
      value: address ? summaryValueMapper.getCountryName(state.countries, address.mailingCountry) : '',
    },
    {
      keyType: summaryRowTypes.SUMMARY_ROW_TXT,
      valueType: summaryRowTypes.SUMMARY_ROW_TXT,
      key: 'Street Address 1',
      value: address ? address.mailingAddress1 : '',
    },
  ]);

  if (address && address.mailingAddress2) {
    personalInformation = personalInformation.concat([
      {
        keyType: summaryRowTypes.SUMMARY_ROW_TXT,
        valueType: summaryRowTypes.SUMMARY_ROW_TXT,
        key: 'Street Address 2',
        value: address ? address.mailingAddress2 : '',
      },
    ]);
  }

  personalInformation = personalInformation.concat([
    {
      keyType: summaryRowTypes.SUMMARY_ROW_TXT,
      valueType: summaryRowTypes.SUMMARY_ROW_TXT,
      key: 'City',
      value: address ? address.mailingCity : '',
    },
    {
      keyType: summaryRowTypes.SUMMARY_ROW_TXT,
      valueType: summaryRowTypes.SUMMARY_ROW_TXT,
      key: 'State/Province',
      value: address ?
        summaryValueMapper.getRegionName(state.countries, address.mailingCountry, address.mailingRegion) :
        '',
    },
    {
      keyType: summaryRowTypes.SUMMARY_ROW_TXT,
      valueType: summaryRowTypes.SUMMARY_ROW_TXT,
      key: 'Zip/Postal Code',
      value: address ? address.mailingZip : '',
    },
  ]);

  const isTseu = config.tseuChangesEnabled && state.application && state.application.isTSEU;
  const countries = state.countries || [];
  const countryCode = contact && contact.countryOfResidence;
  const isTsel = config.tseuChangesEnabled && isTselCountry(countries, countryCode);
  const showDoNotContact = (isTseu || isTsel) && address && address.doNotContact;
  if (showDoNotContact) {
    personalInformation = personalInformation.concat([
      {
        keyType: summaryRowTypes.SUMMARY_ROW_TXT,
        valueType: summaryRowTypes.SUMMARY_ROW_TXT,
        key: 'Receive Marketing Communications?',
        value: 'No',
      },
    ]);
  }

  return {
    isLoading,
    key: 'personal-info',
    value: personalInformation,
    title: 'Personal Information',
    editLink: '/personal-info',
  };
}

function mapStateToProps(state, ownProps) {
  const groupIndex = ownProps.groupIndex;
  const initialValues = mapStateToInitialValues(state, groupIndex);
  const errorMessage = '';
  const application = state.application;

  return {
    application,
    applicationId: state.applicationId,
    authToken: state.authToken,
    isLoading: initialValues.isLoading,
    entity: initialValues.key,
    summaryInfo: initialValues.value,
    title: initialValues.title,
    editLink: initialValues.editLink,
    errorMessage,
  };
}

function mapDispatchToProps(dispatch) {
  return {
    actions: bindActionCreators(
      Object.assign({}, applicationActions, contactActions, addressActions, identityActions), dispatch,
    ),
  };
}

export default connect(mapStateToProps, mapDispatchToProps)(SummaryPersonalInfoContainer);
